'use client';

import { Fragment } from 'react';
import { FacetValueViewModel, FacetsViewModel, PriceFacetViewModel } from '@/types/api';
import { ONLY_IN_STOCK_PRODUCTS_TITLE } from '@/app/(plp)/constants';
import { usePLPFacetsContext } from '@/app/(plp)/facets-context/facets-context';
import { STOCK_FACET_KEY } from './constants';
import { RemoveAllFilters } from './remove-all-filters';
import { SelectedFacet } from './selected-facet';
import { FilterItemType } from './types';
import { updateSelectedStatus } from './utils/category-helpers';
export function AppliedFilters() {
  const {
    activeFacets,
    setFacetsValues,
    allFacets,
    setOnlyInStock
  } = usePLPFacetsContext();
  if (!setFacetsValues || !setOnlyInStock) return null;
  const removeItemFromFacets = (item: FilterItemType, mainFacetKey: keyof FacetsViewModel, info?: string) => {
    if (!activeFacets) return;
    switch (mainFacetKey) {
      case 'priceFacet':
        {
          const key = info as keyof PriceFacetViewModel;
          setFacetsValues({
            mainFacetKey,
            value: {
              ...activeFacets.priceFacet,
              [key]: null
            }
          });
        }
        break;
      case 'dynamicFacets':
        {
          if (!allFacets || !allFacets.dynamicFacets) return;

          // find index of the array this facet belongs to
          let dynamicFacetGroupIndex: null | number = null;
          allFacets.dynamicFacets.forEach((facetValue, facetIndex) => {
            const index = facetValue.values?.findIndex(innerDF => innerDF.key === (item as FacetValueViewModel).key);
            if (typeof index !== 'undefined' && index >= 0) dynamicFacetGroupIndex = facetIndex;
          });
          if (dynamicFacetGroupIndex === null) return;
          const collection = allFacets.dynamicFacets[dynamicFacetGroupIndex];
          const newValue = (collection.values?.map(f => f.key === item.key ? {
            ...item,
            isSelected: false
          } : f) || []).filter(v => v.isSelected);
          if (!collection) return;
          setFacetsValues({
            mainFacetKey,
            innerKey: collection.key,
            value: newValue
          });
        }
        break;
      case 'categories':
        {
          const clonedList = structuredClone(allFacets?.categories);
          if (!clonedList) return;
          updateSelectedStatus(clonedList, item, false);
          setFacetsValues({
            mainFacetKey,
            value: clonedList
          });
        }
        break;
      case 'brandFacets':
      case 'colorFacets':
        {
          const value = activeFacets[mainFacetKey].map(v => {
            // if found the item, set it as de-selected
            if (v.key === item.key) {
              return {
                ...item,
                isSelected: false
              };
            }
            // item doesn't match current `v`, return original value
            return v;
          }).filter(item => item.isSelected);
          setFacetsValues({
            mainFacetKey,
            value
          });
        }
        break;
      default:
    }
  };
  return !!activeFacets?.count && <div className='flex flex-wrap items-start gap-2 lg:mb-4'>
                <RemoveAllFilters className='hidden lg:block' />

                {Object.entries(activeFacets).map(([key, value]) => {
      if (typeof value === 'string' || typeof value === 'number') return null;
      if (Array.isArray(value)) {
        return value.map(item => <SelectedFacet item={item} mainFacetKey={key as keyof FacetsViewModel} key={item.key} onClick={(item, mainFacetKey) => removeItemFromFacets(item, mainFacetKey)} />);
      } else if (key as keyof FacetsViewModel === 'priceFacet') {
        return <SelectedFacet item={value} mainFacetKey={key as keyof FacetsViewModel} key={key} onClick={(item, mainFacetKey, info) => removeItemFromFacets(item, mainFacetKey, info)} />;
      } else if (key as keyof FacetsViewModel === 'stockFacet') {
        if (activeFacets[STOCK_FACET_KEY]) {
          const onlyInStock = {
            displayNameFa: ONLY_IN_STOCK_PRODUCTS_TITLE
          };
          return <SelectedFacet item={onlyInStock} mainFacetKey={key as keyof FacetsViewModel} key={key} onClick={() => setOnlyInStock(false)} />;
        }
      }
      return <Fragment key={key} />;
    })}
            </div>;
}
export default AppliedFilters;